import EmployerAttachments from './employerAttachments';
import { Postjob } from './postjob';

export class Employer {
    constructor(
        public id: number = null,
        public referenceEmployerId: number = null,
        public username: string= null,
        public companyName: string = null,
        public password: string = null,
        public confirmPassword: string = null,
        public website: string = null,
        public companyRegisterNumber: string = null,
        public phoneNumber: string = null,
        public email: string = null,
        public industry: string = null,
        public address: string = null,
        public logoName: string = null,
        public encryptedLogoName: string = null,
        public promotionalCommunication: string = null,
        public termsAndCondition: string = null,
        public hrdfType: string = null,
        public status:string = null,
        public role:string = null,
        public companyInfo:string = null,
        public companySize:string = null,
        public companySizeVariation:string = null,
        public companyCurrentCity:string = null,
        public companyCurrentState:string = null,
        public companyPostcode:string = null,
        public subsector:string = null,
        public companyWebsite:string= null,
        public queryStatus:string = null,
        public queryDescription:string = null,
        public mailToken: string = null,
        public provider?:string,
        public employerAttachments?: EmployerAttachments[],
        public postjob?: Postjob[],
        public lastLoginAt: Date = null
    ){}
}